import PropTypes from 'prop-types';
import IconButton from '../atom/IconButton';
import useComponentVisible from '../../../../utilities/hooks/useComponentVisible';
import dots from '../../../../assets/icons/ic_three_dots.svg';
import { ReactComponent as EyeIcon } from '../../../../assets/icons/ic_eye.svg';
import { useDictionary } from '../../../../utilities/hooks/UseDictionary';
import moment from 'moment'
import ProfileImage from '../../common/ProfileImage';
import ImageHelper from '../../../../utilities/helpers/ImageHelper';
import { DateFormatHelper } from '../../../../utilities/helpers/DateFormatHelper';
import useRatingPhrase from '../../../../utilities/hooks/UseRatingPhrase';
import { ReactComponent as StarFillIcon } from '../../../../assets/icons/ic_star.svg';

const ProviderReviewsItem = ({ item,onProviderReviewsClicked }) => {
    const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);
    const dictionary = useDictionary();
    const { getPhrase } = useRatingPhrase();


    const onContextClicked = () => {
		setIsComponentVisible(!isComponentVisible);
	};

    const getDate = (date) => {
        if(date) {
            return moment(date* 1000).format('MMM DD, YYYY')
        }
    }
    
	return (
		<tr style={{ cursor: 'pointer' }} className='provider-review-row' onClick={() => onProviderReviewsClicked(item)}>
			<td>
                <div className="booking-customer-container m-zero">
                    <div className='provider-booking-customer-name truncate'>{item.booking.display_id}</div>
                </div>
			</td>
			<td>
				<div className="provider-customers-number">{getDate(item.created_at)}</div>
			</td>
			<td>
                <div className="booking-customer-container m-zero">
                    <ProfileImage name={item.customer.name} photo={item?.customer.avatar_url} size={{ width: 24, height: 24,fontSize: 11, lineHeight: 14 }}/>
                    <div className='provider-booking-customer-name provider-customers-number truncate' style={{marginLeft:8}} title={item.customer.name}>{item.customer.name}</div>
                </div>
			</td>
			<td>
                <div className="d-flex items-center">
                    <img
                        className="provider-review-expe-img"
                        onError={(e) => {
                            e.currentTarget.src = '';
                        }}
                        src={
                            item.experience?.thumbnail_url
                                ? ImageHelper.getFullImageUrl(
                                    item.experience?.thumbnail_url
                                )
                                : ''
                        }
                    />
                    <div className='truncate booking-experience-title' title={item.experience.title}>{item.experience.title}</div>
                </div>
			</td>
			<td>
				<div className="provider-customers-duration">{DateFormatHelper.monthYearTimeFormat(item.slot.start_time)}</div>
			</td>
			<td>
                <div className="provider-reviews-phrase">
                    {getPhrase(parseInt(item.rating))}
                </div>
			</td>
			<td>
                <div className="provider-customers-duration d-flex" style={{gap:4}}>
                    <div>
                        {parseFloat(item.rating).toFixed(1)}
                    </div>
                    <StarFillIcon width={12} height={12} style={{ color: '#22264C', padding:'2px 0px' }} />
                </div>
			</td>
            <td>
				<div className="provider-customers-actions-wrapper d-flex-center">
					<IconButton onClickIcon={onContextClicked} activeState={isComponentVisible} styleObject={{width: '32px',height: '32px',borderRadius: '6px'}}>
						<img src={dots} />
					</IconButton>

					<div ref={ref} className="provider-customers-action-menus-container">
						{isComponentVisible ? (
							<>
                                <div className="provider-customers-actions-container">
                                    <div className="provider-customers-action-container" onClick={(e) => {e.stopPropagation();onProviderReviewsClicked(item)}}>
                                        <EyeIcon />
                                        <div>{dictionary.view}</div>
                                    </div>
                                </div>
							</>
						) : null}
					</div>
				</div>
			</td>
		</tr>
	);
};

ProviderReviewsItem.propTypes = {
	item: PropTypes.object,
    onProviderReviewsClicked: PropTypes.func,
    columns: PropTypes.object
};

export default ProviderReviewsItem;